(function(){
  function init(row){
    if(row.dataset.car) return; row.dataset.car='1';
    var items=row.children; if(items.length<2) return;
    var c=document.createElement('div'); c.className='car';
    c.innerHTML='<span class="car__b"><button type="button" aria-label="Previous">&#8249;</button><button type="button" aria-label="Next">&#8250;</button></span>';
    row.parentNode.insertBefore(c,row.nextSibling);
    var b=c.querySelectorAll('button');
    function step(){return items[0].getBoundingClientRect().width+parseFloat(getComputedStyle(row).columnGap||14);}
    function upd(){b[0].disabled=row.scrollLeft<4;b[1].disabled=row.scrollLeft+row.clientWidth>=row.scrollWidth-4;}
    b[0].addEventListener('click',function(){row.scrollBy({left:-step()});});
    b[1].addEventListener('click',function(){row.scrollBy({left:step()});});
    row.addEventListener('scroll',function(){window.requestAnimationFrame(upd);},{passive:true});
    window.addEventListener('resize',upd); upd();
  }
  function all(){document.querySelectorAll('.four').forEach(init);}
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();
